import { Component, computed, inject, input } from "@angular/core";
import { ApiErrorUtil } from "../../util/ApiErrorUtil";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";


@Component({
  selector: "app-page-error-uif",
  imports: [TranslocoDirective],
  templateUrl: "./page-error-uif.component.html",
  styles: ``,
})
export class PageErrorUifComponent {
  //#region I/O
  pageErrorTypeOverride = input<undefined | "unknown" | "not-found" | "server-error" | "permission-denied">(undefined);
  pageErrorQueryError = input<Error | null | undefined>(undefined);
  //#endregion
  //#region Fields
  translocoService = inject(TranslocoService);

  title = computed(() => {
    if (!this.pageErrorTypeOverride()) {
      return this.translocoService.translate("error.default.title");
    }

    switch (this.pageErrorTypeOverride()) {
      case "not-found":
        return this.translocoService.translate("error.notFound.title");
      case "server-error":
        return this.translocoService.translate("error.server.title");
      case "permission-denied":
        return this.translocoService.translate("error.permissionDenied.title");
    }

    return this.translocoService.translate("error.unknown.title");
  });
  description = computed(() => {
    if (!this.pageErrorTypeOverride()) {
      return ApiErrorUtil.getErrorMessage(this.pageErrorQueryError());
    }

    switch (this.pageErrorTypeOverride()) {
      case "not-found":
        return this.translocoService.translate("error.notFound.message");
      case "server-error":
        return this.translocoService.translate("error.server.message");
      case "permission-denied":
        return this.translocoService.translate("error.permissionDenied.message");
    }

    return this.translocoService.translate("error.unknown.message");
  });

  debugCode = computed(() => {
    return "";
  });
  //#endregion
}
